import isString from 'lodash/isString'

const makeFullUrl = (url = null) => {
  if (!url) {
    console.error(`makeFullUrl value should be not empty. Given ${url} with type ${typeof url}`)

    return null
  }

  if (!isString(url)) {
    console.error(`makeFullUrl value has incorrect type. Expected a string but given ${url} with type ${typeof url}`)

    return null
  }

  const hasProtocol = url.startsWith('http://') || url.startsWith('https://')

  if (hasProtocol) {
    return url
  }

  const isPath = !url.includes(window.location.origin) && url.charAt(0) === '/'

  return isPath ? `${window.location.origin}${url}` : `${window.location.origin}/${url}`
}

export default makeFullUrl
